import type { CustomerNavItem, NavItem } from "@scott/ui-d2c/types";
import type React from "react";
import { CustomerNav } from "./customer-nav";
import { useNavigationStore } from "./use-navigation-store";

interface FirstPanelProps {
  isActive: boolean;
  navItems: NavItem[];
  customerNavItems: CustomerNavItem[];
  onPanelChange: (panel: string, data: NavItem) => void;
}

const FirstPanel: React.FC<FirstPanelProps> = ({
  isActive,
  navItems,
  customerNavItems,
  onPanelChange,
}) => {
  const { setLevel, pushToDataLayer } = useNavigationStore();

  return (
    <div
      className={`fixed top-0 bottom-0 left-0 z-10 w-full overflow-clip bg-nav-bg-secondary pl-6 font-nav-paragraph font-nav-weight text-nav-color transition-transform duration-300 ease-in-out lg:w-[420px] ${isActive ? "translate-x-0" : "-translate-x-full"}`}
    >
      <div className="my-5 h-[88px]" />
      <div className="relative left-12 max-h-[calc(100%-120px)] w-[calc(100%-64px)] max-w-full overflow-y-auto p-0 pb-10 uppercase">
        <ul className="space-y-4 text-xl">
          {navItems.map((item, index) => {
            const content = (
              <span
                className={`m-0 cursor-pointer px-0 py-1 font-bold hover:text-nav-hover ${
                  item.onSale === "true"
                    ? "text-sale hover:text-salehover"
                    : "nosale"
                }`}
              >
                {item.title}
              </span>
            );

            return (
              <li key={item.title}>
                {item.componentData?.link?.url &&
                !item.componentData?.navigationNode.children ? (
                  <a
                    href={item.componentData?.link?.url}
                    onClick={() => {
                      setLevel(1, item.titleEN, index);
                      pushToDataLayer();
                    }}
                  >
                    {content}
                  </a>
                ) : (
                  <div
                    onClick={() => {
                      setLevel(1, item.titleEN, index);
                      onPanelChange("second", item);
                    }}
                  >
                    {content}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        <div className="m-2 mt-8 h-px w-[calc(100%-64px)] border-nav-gray border-t pt-4" />
        <CustomerNav navItems={customerNavItems} />
      </div>
    </div>
  );
};

export { FirstPanel };
